import React from 'react';
import connect from 'Shared/connect';
import { MEDIUM } from 'Shared/breakpoints';
import classnames from 'classnames';
import * as styles from './base.scss';
import LinkWithAlcoholWarning from 'Shared/LinkWithAlcoholWarning';
const ImageContentCard = ({ className, ticket, isDesktop, targetLink, imageUrl, appearance, containsAlcoholInfo, onClick, title, }) => (appearance !== 'large' || isDesktop) && (React.createElement("div", { className: classnames(styles.child, className, styles[appearance]) },
    React.createElement(LinkWithAlcoholWarning, { className: styles.href, "data-ticket": ticket, targetLink: targetLink, hasAlcoholWarning: containsAlcoholInfo, onClick: onClick, text: title },
        React.createElement("div", { className: styles.image, style: { backgroundImage: `url(${imageUrl})` } }))));
export default connect((state) => ({
    isDesktop: state.currentBreakpoint >= MEDIUM,
}), (dispatch) => ({}))(ImageContentCard);
